import ActionTypes from "./types";
import userAPIHelper from "../../helpers/api/userAPIHelper";
import vehicletypeAPIHelper from "../../helpers/api/vehicletypeAPIHelper";

/**
 * Get list for User
 * @param {String} [token] Token for API calling
 * @param {Function} [successCallback=null] (Optional) Callback function after successful API call
 * @param {Function} [failCallback=null] (Optional) Callback function after failed API call
 * @returns {function(...[*]=)} Dispatch function of Redux action
 */
export function getList(token, successCallback = null, failCallback = null) {
  return (dispatch) => {
    userAPIHelper.getList(
      token,
      (response) => {
        const {
          responseDetail: { data },
        } = response;
        dispatch({
          type: ActionTypes.USER_GET_LIST,
          data,
        });
        if (typeof successCallback === "function") successCallback(response);
      },
      (error) => {
        if (typeof failCallback === "function") failCallback(error);
      }
    );
  };
}

/**
 * Select the user for form input
 * @param {Object} data The data of selected user
 * @returns {{data: *, type: string}} Redux Action
 */
export function select(data) {
  return {
    type: ActionTypes.USER_SELECT,
    data,
  };
}
/**
 * Create new user
 * @param {Object} data Data for creating a user
 * @param {String} [token] Token for API calling
 * @param {Function} [successCallback=null] (Optional) Callback function after successful API call
 * @param {Function} [failCallback=null] (Optional) Callback function after failed API call
 * @returns {function(...[*]=)} Dispatch function of Redux action
 */
export function create(data, token, successCallback, failCallback) {
  return (dispatch) => {
    userAPIHelper.create(
      data,
      token,
      (response) => {
        const { responseCode } = response;
        if (responseCode !== 200) {
          if (typeof failCallback === "function") failCallback(response);
          return;
        }
        dispatch({
          type: ActionTypes.USER_SELECT,
          data: null,
        });
        if (typeof successCallback === "function") successCallback(response);
      },
      (error) => {
        if (typeof failCallback === "function") failCallback(error);
      }
    );
  };
}

/**
 * Update existing user
 * @param {String} id ID of the user to be updated
 * @param {Object} data Data for updating user
 * @param {String} [token] Token for API calling
 * @param {Function} [successCallback=null] (Optional) Callback function after successful API call
 * @param {Function} [failCallback=null] (Optional) Callback function after failed API call
 * @returns {function(...[*]=)} Dispatch function of Redux action
 */
export function update(id, data, token, successCallback, failCallback) {
  return (dispatch) => {
    userAPIHelper.update(
      id,
      data,
      token,
      (response) => {
        const { responseCode } = response;
        if (responseCode !== 200) {
          if (typeof failCallback === "function") failCallback(response);
          return;
        }
        dispatch({
          type: ActionTypes.USER_SELECT,
          data: null,
        });
        if (typeof successCallback === "function") successCallback(response);
      },
      (error) => {
        if (typeof failCallback === "function") failCallback(error);
      }
    );
  };
}

export function remove(id, token, successCallback, failCallback) {
  return (dispatch) => {
    userAPIHelper.remove(
      id,
      token,
      (response) => {
        const { responseCode } = response;
        if (responseCode !== 200) {
          if (typeof failCallback === "function") failCallback(response);
          return;
        }
        dispatch({
          type: ActionTypes.USER_SELECT,
          data: null,
        });
        if (typeof successCallback === "function") successCallback(response);
      },
      (error) => {
        if (typeof failCallback === "function") failCallback(error);
      }
    );
  };
}

const UserActions = { getList, select, create, update, remove };
export default UserActions;
